import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeArrowIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="shapeArrow" ref={ref} {...props}>
      <path d="M20.53,4.53,5.81,19.25H12a.75.75,0,0,1,0,1.5H4a.72.72,0,0,1-.29-.06A.79.79,0,0,1,3.25,20V12a.75.75,0,0,1,1.5,0v6.19L19.47,3.47a.75.75,0,0,1,1.06,0A.74.74,0,0,1,20.53,4.53Z" />
    </Icon>
  ),
) as IconWithRender;

ShapeArrowIcon.displayName = 'ShapeArrowIcon';
ShapeArrowIcon.renderIcon = (props) => <ShapeArrowIcon {...props} />;
export default ShapeArrowIcon;
